import React from "react"
import { Text } from "@jjordy/layout"
import Center from "./Elements/Center"

export default function AppVersion() {
  return (
    <Center style={{ bottom: 0 }}>
      <Text fg="grey">{process.env.REACT_APP_VERSION}</Text>
    </Center>
  )
}
